export function siteBuilderButtonClass(style: string): string {
    if (style === "pill") {
        return "rounded-full bg-[var(--site-primary)] text-[var(--site-on-primary)] shadow-sm";
    }

    if (style === "outline") {
        return "rounded-[var(--site-radius)] border border-[var(--site-primary)] bg-transparent text-[var(--site-primary)]";
    }

    return "rounded-[var(--site-radius)] bg-[var(--site-primary)] text-[var(--site-on-primary)] shadow-sm";
}
